module.exports = __webpack_public_path__ + "static/media/check.9e3a34d9.svg";